import React from 'react'
import { Button, Form } from 'antd'
import { useTranslation } from 'react-i18next'

import useMasterData from 'hooks/useMasterData'
import useQueryString from 'hooks/useQueryString'

import FullWidthSpace from 'components/FullWidthSpace'
import LoadingIcon from 'components/LoadingIcon'
import DefaultRegisterFormInput from './DefaultRegisterFormInput'

import type { UserField } from 'graphQL/useGetRoleRegistable/interface'
import GeneralFormInput from 'components/GeneralFormInput'

interface RegisterFormProps {
  loading?: boolean
  dataKeyList: string[]
  fieldList: UserField[]
  onFinish: (data: any) => void
}

const RegisterForm: React.FC<RegisterFormProps> = ({ loading, dataKeyList, fieldList, onFinish }) => {
  const { t } = useTranslation('register')
  const query = useQueryString()
  const email = query.get('email')

  const masterData = useMasterData({
    parentKeys: [...dataKeyList, 'DIALING_CODE', 'NAME_PREFIX'],
  })

  if (masterData.loading) {
    return <LoadingIcon />
  }

  return (
    <Form
      name="registerForm"
      layout="vertical"
      labelAlign="left"
      onFinish={onFinish}
      initialValues={{
        email,
      }}
    >
      <FullWidthSpace size={16} direction="vertical">
        <DefaultRegisterFormInput namePrefix={masterData.masterDataList.NAME_PREFIX} email={email} />

        <GeneralFormInput fieldList={fieldList} masterDataList={masterData.masterDataList} />

        <Form.Item>
          <Button block loading={loading} type="primary" htmlType="submit">
            {t('button')}
          </Button>
        </Form.Item>
      </FullWidthSpace>
    </Form>
  )
}

export default RegisterForm
